import async from 'components/Async';
import PageRouteUtil from 'routes/util';
import { path as AdvertiserRulesPagePath } from './TrafficRules/AdvertiserRulesPage/AdvertiserRulesFormPage';
import { path as PublisherRulesPagePath } from './TrafficRules/PublisherRulesPage/PublisherRulesFormPage';
import { path as CampaignMangerFormPagePath } from './CampaignManagerPage/CampaignManagerFormPage';
import access from '../../constants/access';
import { role } from '../../constants';

const CampaignManagerPage = async(() => import('./CampaignManagerPage'));
const CampaignManagerFormPage = async(() => import('./CampaignManagerPage/CampaignManagerFormPage'));
const BulkEditPage = async(() => import('./CampaignManagerPage/CampaignManagerFormPage/BulkEditPage'));
const EditAdvertiserPage = async(() => import('./EditAdvertiserPage'));
const EditCampaignPage = async(() => import('./EditCampaignPage'));
const KeywordSearchToolPage = async(() => import('./KeywordSearchToolPage'));
const PublisherReportPage = async(() => import('./PublisherReportPage'));
const ReportingPage = async(() => import('./ReportingPage'));
const TrafficQualityReportPage = async(() => import('./TrafficQualityReportPage'));
const AdvertiserRulesPage = async(() => import('./TrafficRules/AdvertiserRulesPage'));
const AdvertiserRulesFormPage = async(() => import('./TrafficRules/AdvertiserRulesPage/AdvertiserRulesFormPage'));
const PublisherRulesPage = async(() => import('./TrafficRules/PublisherRulesPage'));
const PublisherRulesFormPage = async(() => import('./TrafficRules/PublisherRulesPage/PublisherRulesFormPage'));
const BillingSummaryPage = async(() => import('./BillingSummaryPage'));
const BillingDetailsPage = async(() => import('./Billing/BillingDetailsPage'));

const sponsoredAdsRouteList = [
   {
      path: '/sponsored-ads/campaign-manager',
      component: CampaignManagerPage,
   },
   {
      path: CampaignMangerFormPagePath,
      component: CampaignManagerFormPage,
      access: access.generate.roleAccess(
         {
            partner: [
               role.partner.admin,
               role.partner.advertiserCentralExternal,
               role.partner.advertiserCentralInternal,
            ],
         },
      ),
   },
   {
      path: '/sponsored-ads/campaign-manager/bulk-edit',
      component: BulkEditPage,
      access: access.generate.roleAccess(
         {
            partner: [
               role.partner.admin,
               role.partner.advertiserCentralInternal,
               role.partner.advertiserCentralExternal,
            ],
         },
      ),
   },
   {
      path: '/sponsored-ads/billing/details',
      component: BillingDetailsPage,
      access: access.generate.roleAccess(
         {
            partner: [
               role.partner.admin,
               role.partner.advertiserCentralExternal,
               role.partner.advertiserCentralInternal,
            ],
         },
      ),
   },
   {
      path: '/sponsored-ads/edit-advertiser',
      component: EditAdvertiserPage,
   },
   {
      path: '/sponsored-ads/edit-campaign',
      component: EditCampaignPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/sponsored-ads/keyword-search-tool',
      component: KeywordSearchToolPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/sponsored-ads/publisher-report',
      component: PublisherReportPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/sponsored-ads/reporting',
      component: ReportingPage,
   },
   {
      path: '/sponsored-ads/traffic-quality-report',
      component: TrafficQualityReportPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/sponsored-ads/traffic-rules/advertiser-rules',
      component: AdvertiserRulesPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: AdvertiserRulesPagePath,
      component: AdvertiserRulesFormPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/sponsored-ads/traffic-rules/publisher-rules',
      component: PublisherRulesPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: PublisherRulesPagePath,
      component: PublisherRulesFormPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
   {
      path: '/sponsored-ads/billing/summary',
      component: BillingSummaryPage,
      access: access.getAdminAccessByApp.sponsoredAds,
   },
];

export default PageRouteUtil.getPageRouteListHavingDefaultProperties(sponsoredAdsRouteList);
